import React, { useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import HeaderTopbar from '../HeaderTopbar/HeaderTopbar'
import MobileMenu from '../MobileMenu/MobileMenu'
import Logo from '../../images/logoj.png'


const Header = (props) => {
    const [menuActive, setMenuState] = useState(false);
    const location = useLocation();
    
    const isProductPage = location.pathname.startsWith('/products/');
    
    const SubmitHandler = (e) => {
        e.preventDefault()
    }

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <header id="header" className={props.topbarNone}>
            <HeaderTopbar />
            <div className={`wpo-site-header ${props.hclass}`}>
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                                <div className="mobail-menu">
                                    <MobileMenu />
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-9 col-9">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/home"><img src={Logo}
                                        alt="" style={{width: '220px', height: 'auto'}} /></Link>
                                </div>
                            </div>
                            <div className="col-lg-7 d-none d-lg-block">
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        <li>
                                            <NavLink onClick={ClickHandler} to="/home">Home</NavLink>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <NavLink onClick={ClickHandler} to="/about">About</NavLink>
                                            <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/about#why-choose-us">Why Choose Us</Link></li>
                                                <li><Link onClick={ClickHandler} to="/about#certificates">Certificates</Link></li>
                                            </ul>
                                        </li>
                                         <li className={`menu-item-has-children ${isProductPage ? 'active' : ''}`}>
                                            <Link to="#">Products</Link>
                                            <ul className="sub-menu">
                                                <li><NavLink onClick={ClickHandler} to="/products/hydrochloric-acid">Hydrochloric Acid</NavLink></li>
                                                <li><NavLink onClick={ClickHandler} to="/products/activated-carbon">Activated Carbon</NavLink></li>
                                                <li><NavLink onClick={ClickHandler} to="/products/hydrated-lime">Hydrated Lime</NavLink></li>
                                                <li><NavLink onClick={ClickHandler} to="/products/quick-lime">Quick Lime</NavLink></li>
                                                <li><NavLink onClick={ClickHandler} to="/products/dolomite">Dolomite</NavLink></li>
                                                <li><NavLink onClick={ClickHandler} to="/products/dimethyl-sulphate">Di Methyl Sulphate</NavLink></li>
                                                <li><NavLink onClick={ClickHandler} to="/products/sodium-aluminate">Sodium Aluminate</NavLink></li>
                                            </ul>
                                        </li>
                                        <li><NavLink onClick={ClickHandler} to="/industries">Industries</NavLink></li>
                                    </ul>

                                </div>
                            </div>
                            <div className="col-lg-2 d-none d-lg-block">
                                <div className="header-right">
                                    <div className="header-search-form-wrapper">
                                        <div className="cart-search-contact">
                                            <button onClick={() => setMenuState(!menuActive)} className="search-toggle-btn"><i
                                                className={`ti-search ${menuActive ? "ti-close" : "ti-search"}`}></i></button>
                                            <div className={`header-search-form ${menuActive ? "header-search-content-toggle" : ""}`}>
                                                <form onSubmit={SubmitHandler}>
                                                    <div>
                                                        <input type="text" className="form-control"
                                                            placeholder="Search here..." />
                                                        <button type="submit"><i
                                                            className="fi ti-search"></i></button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="close-form">
                                        <Link onClick={ClickHandler} className="theme-btn contact-btn-green" to="/contact">CONTACT US</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}

export default Header;